<div class="modal bg-navy" [ngClass]="classes">
  <div class="modal__header">
    <div>
      <a class="modal__back" href="" *ngIf="backText" (click)="backAction($event)">
        <svg-icon src="assets/images/svg/icons/main-nav/back.svg"></svg-icon>
        {{ backText }}
      </a>
    </div>
    <div>
      <a class="modal__close" href="" (click)="closeAction($event)">
        {{ closeText }}
        <svg-icon src="assets/images/svg/icons/main-nav/close.svg"></svg-icon>
      </a>
    </div>
  </div>
  <div class="modal__content">
    <ng-content></ng-content>
  </div>
</div>
